import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { Typography } from '../../../../components/DesignSystem';
import LiquidIDThumbnails from '../LiquidIDThumbnails';

interface CollectionNameProps {
    $expanded?: boolean;
}

export const CollectionName = styled(motion.div)<CollectionNameProps>`
    display: flex;
    align-items: center;
    align-content: center;
    margin-top: 8px;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        margin-left: 8px;
        margin-top: 0;
    }
`;

interface Props {
    $preview: boolean;
}

export const ExpandedLiquidIDItemDetailsWrapper = styled(motion.div)<Props>`
    position: fixed;
    bottom: 190px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    justify-content: space-between;
    padding: 0 40px;
    width: max-content;
    max-width: 100vw;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        padding: 0;
        top: 0;
        bottom: 0;
        right: 40px;
        width: 35%;
        height: 100vh;
        min-width: max-content;
        row-gap: 40px;
        justify-content: center;
        z-index: 2;
        > * {
            transform: translateY(-80px);
        }
        ${({ $preview }) =>
            $preview &&
            css`
                justify-content: flex-start;
                height: calc(100% - 70px);

                top: 70px;
                > * {
                    transform: none;
                    flex: 1 1 0;
                }
            `}
    }
`;

export const ItemDetails = styled.div`
    pointer-events: all;
    place-content: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;

export const StyledTitle = styled(Typography)`
    font-size: 25px !important; // Typography component does not support sizes according to breakpoint
    text-shadow:
        0 0 15px rgba(255, 255, 255, 0.45),
        0 0 20px #523df1;
    white-space: nowrap;

    display: flex;
    align-items: center;
    column-gap: 10px;

    svg {
        width: 14px;
        height: 14px;
        fill: none;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: 640px;
        font-size: 75px !important;
        margin: 30px 0 10px;
        display: block;
        align-items: initial;

        svg {
            display: none;
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        max-width: 100%;
    }
`;

export const StyledLiquidIDThumbnails = styled(LiquidIDThumbnails)`
    place-content: flex-start;

    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: block;
        > * {
            justify-content: flex-start;
        }
    }
`;
